import React from "react";

const Locations = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon" {...props}>
    <path
      d="M10 17.4163L14.1248 13.2915C16.4028 11.0135 16.4028 7.32001 14.1248 5.04196C11.8468 2.7639 8.15327 2.7639 5.87521 5.04196C3.59715 7.32001 3.59715 11.0135 5.87521 13.2915L10 17.4163ZM10 19.7733L4.6967 14.4701C1.76777 11.5411 1.76777 6.79238 4.6967 3.86345C7.62563 0.934515 12.3743 0.934515 15.3033 3.86345C18.2323 6.79238 18.2323 11.5411 15.3033 14.4701L10 19.7733ZM10 10.8334C10.9205 10.8334 11.6667 10.0872 11.6667 9.16675C11.6667 8.24627 10.9205 7.50008 10 7.50008C9.0795 7.50008 8.33333 8.24627 8.33333 9.16675C8.33333 10.0872 9.0795 10.8334 10 10.8334ZM10 12.5001C8.15905 12.5001 6.66667 11.0077 6.66667 9.16675C6.66667 7.3258 8.15905 5.83341 10 5.83341C11.8409 5.83341 13.3333 7.3258 13.3333 9.16675C13.3333 11.0077 11.8409 12.5001 10 12.5001Z"
      fill="currentColor"
    />
  </svg>
);
export default Locations;
